import React from 'react';
import {
    EuiButton,
    EuiFlexGroup,
    EuiFlexItem,
    EuiModal,
    EuiModalBody,
    EuiModalHeader,
    EuiModalHeaderTitle,
    EuiSpacer,
    EuiText,
} from '@elastic/eui';

const PREVIEW_WIDTH = 240;

const formatRatio = (ratio) => {
    if (ratio >= 1) return `${+ratio.toFixed(2)}:1`;
    return `1:${+(1 / ratio).toFixed(2)}`;
};

const frameStyle = {
    width: PREVIEW_WIDTH,
    maxWidth: '100%',
    border: '1px dashed #98a2b3',
    backgroundColor: '#f5f7fa',
    overflow: 'hidden',
};

const PreviewTile = ({ title, caption, ratio, url, objectFit }) => (
    <EuiFlexItem grow={false} style={{ width: PREVIEW_WIDTH, maxWidth: '100%' }}>
        <EuiText size='s'>
            <strong>{title}</strong>
        </EuiText>
        <EuiSpacer size='xs' />
        <div style={{ ...frameStyle, height: Math.round(PREVIEW_WIDTH / ratio) }}>
            <img src={url} alt={title} style={{ width: '100%', height: '100%', objectFit, display: 'block' }} />
        </div>
        <EuiSpacer size='xs' />
        <EuiText size='xs' color='subdued'>
            {caption}
        </EuiText>
    </EuiFlexItem>
);

const UploadImageErrorMsg = ({ message, onClose, preview, onContinue }) => {
    const showPreview = preview?.url && preview?.width && preview?.height && preview?.aspectRatio;
    const fileRatio = showPreview ? preview.width / preview.height : null;
    const requiredLabel = showPreview ? formatRatio(preview.aspectRatio) : '';

    return (
        <EuiModal onClose={onClose} style={showPreview ? { maxWidth: 860 } : undefined}>
            <EuiModalHeader>
                <EuiModalHeaderTitle>
                    <h1>Error</h1>
                </EuiModalHeaderTitle>
            </EuiModalHeader>
            <EuiModalBody>
                <EuiText>
                    <p>{message}</p>
                </EuiText>
                {showPreview ? (
                    <>
                        <EuiSpacer size='m' />
                        <EuiFlexGroup gutterSize='l' wrap responsive={false} alignItems='flexStart'>
                            <PreviewTile
                                title='Your GIF'
                                caption={`${preview.width} × ${preview.height} px (${formatRatio(fileRatio)})`}
                                ratio={fileRatio}
                                url={preview.url}
                                objectFit='fill'
                            />
                            <PreviewTile
                                title={`Stretched to ${requiredLabel}`}
                                caption='Squeezed to fit the banner, so it looks distorted'
                                ratio={preview.aspectRatio}
                                url={preview.url}
                                objectFit='fill'
                            />
                            <PreviewTile
                                title={`Cropped to ${requiredLabel}`}
                                caption='Fills the banner, but the top and bottom (or sides) are cut off'
                                ratio={preview.aspectRatio}
                                url={preview.url}
                                objectFit='cover'
                            />
                        </EuiFlexGroup>
                    </>
                ) : null}
                <EuiFlexGroup gutterSize='s' responsive={false} style={{ marginTop: '16px' }}>
                    <EuiFlexItem grow={false}>
                        <EuiButton onClick={onClose} fill>
                            Close
                        </EuiButton>
                    </EuiFlexItem>
                    {onContinue ? (
                        <EuiFlexItem grow={false}>
                            <EuiButton onClick={onContinue} color='warning'>
                                Continue &amp; crop
                            </EuiButton>
                        </EuiFlexItem>
                    ) : null}
                </EuiFlexGroup>
            </EuiModalBody>
        </EuiModal>
    );
};

export default UploadImageErrorMsg;
